import { AppAction } from "../../root/AppAction";
import DocumentEvent from "../events/DocumentEvent";
/*資料レデューサー */
export interface DocumentStore {
    url: string;
    isLoading: boolean;
}

/*資料レデューサー初期値設定 */
const initialDocumentStore: DocumentStore = {
    url: "",
    isLoading: false,
};

export function document(state: DocumentStore = initialDocumentStore, action: AppAction) {
    switch (action.type) {
        // SlideStockの資料ダウンロード
        case DocumentEvent.GetSlideStockDocumentStarted:
            return {
                ...state,
                url: "",
                isLoading: true,
            };

        case DocumentEvent.GetSlideStockDocumentCompleted:
            return {
                ...state,
                url: action.url,
                isLoading: false,
            };

        // 動画の資料ダウンロード
        case DocumentEvent.GetVideoDocumentStarted:
            return {
                ...state,
                url: "",
                isLoading: true,
            };

        case DocumentEvent.GetVideoDocumentCompleted:
            return {
                ...state,
                url: action.url,
                isLoading: false,
            };

        // 資料ダウンロードリンクをリセットする。
        case DocumentEvent.ResetDocumentUrl:
            return {
                ...state,
                url: "",
            };
        default:
            return state;
    }
}
